import { baseUrl } from './api.js';

/**
 * Krok D6b bod 1 — casomíra prace u zakazky (start/stop, soucet minut).
 *
 * ROZHODNUTI D6b-1: tahle trojice cest jde pres `fetch`, ne pres `apiClient`.
 * Typovany klient cte VYGENEROVANE OpenAPI (`@reos/api-client`), ktere se
 * generuje vlastnim krokem — dokud tam nove cesty nejsou, `apiClient.GET`
 * by se neprelozil. Tvar odpovedi je proto napsany tady a je to TENTYZ tvar,
 * ktery vraci `timerSchema`/`entrySchema` v `apps/api/src/routes/dd-work-timer.ts`
 * (zod schema odpovedi, takze server neposle nic jineho, nez co je nize).
 *
 * Chyba se nepolyka: 409 („uz bezi" / „nic nebezi") je stav, ktery UI ukaze
 * jako text ze serveru — zadny druhy hardcodovany text v adminu (CLAUDE.md §5).
 */

export interface WorkTimeEntry {
  readonly id: string;
  readonly caseId: string;
  readonly taskId: string | null;
  readonly startedAt: string;
  readonly stoppedAt: string | null;
  readonly minutes: number | null;
  readonly startedBy: string;
  readonly note: string | null;
}

export interface CaseWorkTimer {
  readonly running: WorkTimeEntry | null;
  readonly totalMinutes: number;
  readonly entries: readonly WorkTimeEntry[];
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${baseUrl}${path}`, { credentials: 'include', ...init });
  if (!response.ok) {
    const problem = (await response.json().catch(() => null)) as
      | { detail?: string; title?: string }
      | null;
    throw new Error(problem?.detail ?? problem?.title ?? `HTTP ${response.status}`);
  }
  return (await response.json()) as T;
}

export async function getCaseWorkTimer(caseId: string): Promise<CaseWorkTimer> {
  return call<CaseWorkTimer>(`/v1/duediligence/cases/${caseId}/work-timer`);
}

export async function startCaseWorkTimer(
  caseId: string,
  body: { taskId?: string; note?: string } = {},
): Promise<WorkTimeEntry> {
  return call<WorkTimeEntry>(`/v1/duediligence/cases/${caseId}/work-timer/start`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function stopCaseWorkTimer(caseId: string): Promise<WorkTimeEntry> {
  return call<WorkTimeEntry>(`/v1/duediligence/cases/${caseId}/work-timer/stop`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({}),
  });
}
